import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom"
import moment from "moment"
import ReactMarkdown from 'react-markdown'
import { StyledCard } from './style';
import { Card } from 'antd';
import { fetchCoachingDetails } from '../../actions/coaching'
import { StyledContent } from '../../styles/mixins'

class CoachingView extends Component {

  state = {
    coachings: [],
  }

  async componentDidMount(){
    const user_uid = localStorage.getItem('user_uid')
    if (user_uid) {
      const coachings = await fetchCoachingDetails(user_uid)
      if (coachings && coachings.data && coachings.data.data && coachings.data.data.coachingclients && coachings.data.data.coachingclients.length > 0) {
        this.setState({
          coachings: coachings.data.data.coachingclients[0].coachings || []
        })
      }
    }
  }

  render() {
    const { coachings } = this.state
    return (
        <StyledContent>
            <Card title="Coachings" bordered={false}>
              { coachings && coachings.length ?
                  coachings.map((coaching,i) => (
                      <div className="d-inline-block mr-2" >
                          <StyledCard title={<Link style={{color: 'inherit'}} to={`/coaching/${coaching.id}`}>{coaching ? moment(coaching.createdAt).format("MM-DD-YYYY"): ""} <span>Hours Used:{coaching.hoursUsed || ''}</span></Link>} style={{width: 250}}>
                              <ReactMarkdown escapeHtml={false} source={coaching.notes} />
                          </StyledCard>
                      </div>
                  )) : null
              }
            </Card>
        </StyledContent>
    )
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories.categoriesList
})

export default connect(mapStateToProps, null)(CoachingView)




// WEBPACK FOOTER //
// ./src/components/view-coaching/index.js